<form [formGroup]="gstFeeForm" novalidate>
  <mat-form-field>
    <label>{{ getGSTLabel() }}<span *ngIf="showAsterisk" class="required">*</span></label>
    <mat-select id="gst-rate-dropdown"
      formControlName="selectedGSTRate"
      floatPlaceholder="never"
      placeholder="Select One" i18n-placeholder>
      <mat-option *ngFor="let gstRate of gstRates" [value]="gstRate.value">
        <span id="select-{{gstRate.value}}-gst-rate">{{ gstRate.label }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
